import React, { useState, useEffect } from 'react';
import { useHistory } from "react-router-dom";

import axios from 'axios';

import { useMsal, useAccount, AuthError } from "@azure/msal-react";
import { silentRequest } from "../../authConfig";

//import * as signalR from "@microsoft/signalr";

import paginate from 'jw-paginate';

import { Pagination } from '@fluentui/react-experiments/lib/Pagination';

import CountUp from 'react-countup';

import {
  //TextField, 
  //DetailsList,
  DetailsListLayoutMode,
  ShimmeredDetailsList,
  //Selection,
  SelectionMode,
  //IColumn, 
  mergeStyleSets,
  TooltipHost,
  //Fabric,
  ActionButton,
  Icon,
  //ProgressIndicator,
  //Label,
  Spinner,
  SpinnerSize,
  CommandBar,
  Stack,
  DocumentCard,
  //DocumentCardActivity,
  DocumentCardTitle,
  DocumentCardDetails,
  DocumentCardLogo,
  //DocumentCardStatus,
  DocumentCardType,
  Text,
  DefaultButton
  //Pagination
  //initializeIcons
} from '@fluentui/react';

import {
  getFileTypeIconProps,
  //FileIconType 
} from '@fluentui/react-file-type-icons';

const API_URL = process.env.REACT_APP_API_URL;
const ADMIN_API_URL = process.env.REACT_APP_ADMIN_API_URL;

const homeStyles = {
  //width: '208',
  //height: '10vh',
  //width: 185,
  //height: 70,
  //boxSizing: 'border-box',
  //border: '1px solid #eee',
  //overflowY: 'auto',
  //paddingTop: '10vh',    
  //background: '#FFFFFF',
  //background: '#106ebe',
  border: 0,
  /* paddingTop: '2%',
  paddingLeft: '2%',
  paddingRight: '2%', */
  margin: 0,
  //minHeight: '100vh',
  width: '100%',
  background: '#FAF9F8'

}

//ProgressIndicator
//const centerItem = { display: "flex", alignItems: "center", justifyContent: "center" };
//Progress Indicator Setting
//const intervalDelay = 100;
//const intervalIncrement = 0.01;

const classNames = mergeStyleSets({
  fileIconHeaderIcon: {
    padding: 0,
    fontSize: '16px',
  },
  fileIconCell: {
    textAlign: 'center',
    selectors: {
      '&:before': {
        content: '.',
        display: 'inline-block',
        verticalAlign: 'middle',
        height: '100%',
        width: '0px',
        visibility: 'hidden',
      },
    },
  },
  fileIconImg: {
    verticalAlign: 'middle',
    maxHeight: '16px',
    maxWidth: '16px',
  },
  controlWrapper: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  exampleToggle: {
    display: 'inline-block',
    marginBottom: '10px',
    marginRight: '30px',
  },
  selectionDetails: {
    marginBottom: '20px',
  },
});
/* 
const shimmeredDetailsListProps = {
renderedWindowsAhead: 0,
renderedWindowsBehind: 0,
};
*/

const cardStyles = {
  cardStyles: {
    root: {
      background: 'white',
      //padding: 20,
      //marginRight: '50%',
      //marginRight: '40px',
      //borderTop: '5px solid #0078d4',
      borderLeft: '5px solid #0078d4',
      width: '30%',
      minWidth: '315px',
      //maxWidth: '415px',
      maxWidth: '424px',
      height: '130px',
      //margin: 'auto',
      //padding: '0 10% 0 10% ',
      //display: 'flex',
      //alignItems: 'center',
      //justifyContent: 'center',

    }
  },
  header: {
    root: {
      fontSize: 20,
      fontWeight: 'bold',
      //paddingTop: '5%',
      paddingTop: '20px',
      textAlign: 'center',
      //color: '#696969'
    }
  },
  amount: {
    root: {
      fontSize: 30,
      //paddingBottom: 20,
      //paddingBottom: '8%',
      paddingBottom: '25px',
      //paddingTop: '20%',
      //paddingRight: '20%',
      textAlign: 'center'
    }
  },
};

function formatDateTime(date) {
  //let d = new Date(date).toLocaleString("en-GB", {timeZone: "Asia/Bangkok"}),
  let d = new Date(date),
    month = '' + (d.getMonth() + 1),
    day = '' + d.getDate(),
    year = d.getFullYear(),
    hour = '' + d.getHours(),
    minute = '' + d.getMinutes(),
    second = '' + d.getSeconds()

  //console.log(d.toString());

  if (month.length < 2)
    month = '0' + month;
  if (day.length < 2)
    day = '0' + day;
  if (hour.length < 2)
    hour = '0' + hour;
  if (minute.length < 2)
    minute = '0' + minute;
  if (second.length < 2)
    second = '0' + second;

  return [year, month, day, hour, minute, second].join('');
}

const Documents = (props) => {

  console.log('Home render!!!');

  const history = useHistory();

  const { instance, accounts } = useMsal();
  //const account = useAccount(accounts[0] || {});
  const account = instance.getAllAccounts()[0];

  //let token = b2cauth.getAccessToken();
  //console.log('Bearer', token);

  //const token = props.token;    
  //const token = props.token;    
  //

  //const api_key = props.api_key;
  //console.log('Api-Key:', props.api_key);

  //const items = [];
  const [documents, setDocuments] = useState([]);
  const [items, setItems] = useState([]);
  const [loadDataComplete, setLoadDataComplete] = useState(false);
  const [getNewDocuments, setGetNewDocuments] = useState(true);
  const [totalProcessingDocuments, setTotalProcessingDocuments] = useState(0);
  //const [clickDelete, setClickDelete] = useState(false);
  const [pageData, setPageData] = useState({});
  const [pageSize, setPageSize] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  /* 
      const [pageData, setPageData] = useState({
        totalItems: '',
        currentPage: '',
        pageSize: '',
        totalPages: '',
        startPage: '',
        endPage: '',
        startIndex: '',
        endIndex: '',
        pages: [] 
      });
   */
  //const [percentComplete, setPercentComplete] = useState(0);

  //CommandBars Items
  const [severityType, setSeverityType] = useState({ key: 'all-severity', text: 'Severity ทุกประเภท' });
  const [eventType, setEventType] = useState({ key: 'all', text: 'Event ทุกประเภท' });

  //Display Summary
  const [totalDocuments, setTotalDocuments] = useState(0);
  const [totalSeverityInfo, setTotalSeverityInfo] = useState(0);
  const [totalSeverityWarning, setTotalSeverityWarning] = useState(0);
  const [totalSeverityError, setTotalSeverityError] = useState(0);


  const getMonth = (goBack) => {
    let monthNames = [
      "มกราคม", "กุมภาพันธ์", "มีนาคม", "เมษายน",
      "พฤษภาคม", "มิถุนายน", "กรกฎาคม", "สิงหาคม.",
      "กันยายน", "ตุลาคม", "พฤศจิกายน", "ธันวาคม"
    ];

    let d = new Date();
    //console.log('new Date(): ', d);

    let adjustDate = new Date(d.getFullYear(), d.getMonth() - goBack, 1);

    //d.setMonth(d.getMonth() - goBack);
    //console.log(d.toLocaleDateString());
    //console.log(d.getMonth());

    let year = adjustDate.getFullYear() + 543;

    return {
      month: adjustDate.getMonth(),
      year: adjustDate.getFullYear(),
      key: adjustDate.getMonth() + 1,
      text: monthNames[adjustDate.getMonth()] + ' ' + year
    };
    //return monthNames[d.getMonth()] + ' ' + year;
    //let m = d.getMonth();
    /* 
          let d;
          let year;
          let _month = [];
          
    
          for (let i = 0; i < 6; i++) {
            d = new Date();
            d.setMonth(d.getMonth() - i);
            year = d.getFullYear() + 543;
            _month.push(monthNames[d.getMonth()] + ' ' + year);
          }
    */

    //console.log(_month);

    //return _month;
  }

  const [queryMonth, setQueryMonth] = useState({ key: getMonth(0).key, text: 'เดือนนี้' });

  const getFrom = (month, year) => {
    //let date = new Date();
    let _firstDay = new Date(year, month, 1);
    //let _lastDay = new Date(year, month + 1, 1);
    console.log('First day: ', formatDate(_firstDay));

    return formatDate(_firstDay);
    //setLastDay(formatDate(_lastDay));


    //console.log('Last day: ', formatDate(_lastDay));
  }

  const getTo = (month, year) => {
    //let date = new Date();
    //let _firstDay = new Date(year, month, 1);
    let _lastDay = new Date(year, month + 1, 1);
    console.log('Last day: ', formatDate(_lastDay));

    return formatDate(_lastDay);
    //setLastDay(formatDate(_lastDay));

    //console.log('Fist day: ', formatDate(_firstDay));

  }

  const formatDate = (d) => {
    //let d = new Date(date),
    let month = '' + (d.getMonth() + 1);
    let day = '' + d.getDate();
    let year = d.getFullYear();

    if (month.length < 2)
      month = '0' + month;
    if (day.length < 2)
      day = '0' + day;

    return [year, month, day].join('-');
  }

  function convertDateToUTC() {
    var date = new Date();
    var now_utc = Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(),
      date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds());

    return new Date(now_utc).toISOString();

  }

  const [from, setFrom] = useState(getFrom(getMonth(0).month, getMonth(0).year));
  const [to, setTo] = useState(getTo(getMonth(0).month, getMonth(0).year));

  const commandBarItems = [
    {
      key: severityType.key,
      text: severityType.text,
      // cacheKey: 'myCacheKey', // changing this key will invalidate this item's cache
      iconProps: { iconName: 'ComplianceAudit' },
      subMenuProps: {
        items: [
          {
            key: 'all-severity',
            text: 'Severity ทุกประเภท',
            iconProps: { iconName: 'ComplianceAudit' },
            onClick: () => {
              console.log('Severity ทุกประเภท');
              setSeverityType({ key: 'all-severity', text: 'Severity ทุกประเภท' });

              setLoadDataComplete(false);
              setItems([]);
              setGetNewDocuments(true);

              setTotalDocuments(0);
              setTotalSeverityInfo(0);
              setTotalSeverityWarning(0);
              setTotalSeverityError(0);
            },
            //['data-automation-id']: 'newEmailButton', // optional
          },
          {
            key: 'info',
            text: 'Info Severity',
            iconProps: { iconName: 'ComplianceAudit' },
            onClick: () => {
              console.log('Info Severity');
              setSeverityType({ key: 'info', text: 'Info Severity' });

              setLoadDataComplete(false);
              setItems([]);
              setGetNewDocuments(true);

              setTotalDocuments(0);
              setTotalSeverityInfo(0);
              setTotalSeverityWarning(0);
              setTotalSeverityError(0);
            },
            //['data-automation-id']: 'newEmailButton', // optional
          },
          {
            key: 'warning',
            text: 'Warning Severity',
            iconProps: { iconName: 'ComplianceAudit' },
            onClick: () => {
              console.log('Warning Severity');
              setSeverityType({ key: 'warning', text: 'Warning Severity' });

              setLoadDataComplete(false);
              setItems([]);
              setGetNewDocuments(true);

              setTotalDocuments(0);
              setTotalSeverityInfo(0);
              setTotalSeverityWarning(0);
              setTotalSeverityError(0);
            },
            //['data-automation-id']: 'newEmailButton', // optional
          },  
          {
            key: 'error',
            text: 'Error Severity',
            iconProps: { iconName: 'ComplianceAudit' },
            onClick: () => {
              console.log('Error Severity');
              setSeverityType({ key: 'error', text: 'Error Severity' });

              setLoadDataComplete(false);
              setItems([]);
              setGetNewDocuments(true);

              setTotalDocuments(0);
              setTotalSeverityInfo(0);
              setTotalSeverityWarning(0);
              setTotalSeverityError(0);
            },
            //['data-automation-id']: 'newEmailButton', // optional
          },  
          {
            key: 'critical',
            text: 'Critical Severity',
            iconProps: { iconName: 'ComplianceAudit' },
            onClick: () => {
              console.log('Critical Severity');
              setSeverityType({ key: 'critical', text: 'Critical Severity' });

              setLoadDataComplete(false);
              setItems([]);
              setGetNewDocuments(true);

              setTotalDocuments(0);
              setTotalSeverityInfo(0);
              setTotalSeverityWarning(0);
              setTotalSeverityError(0);
            },
            //['data-automation-id']: 'newEmailButton', // optional
          }                   
        ],
      },

    },
    {
      key: eventType.key,
      text: eventType.text,
      // cacheKey: 'myCacheKey', // changing this key will invalidate this item's cache
      iconProps: { iconName: 'ComplianceAudit' },
      subMenuProps: {
        items: [
          {
            key: 'all',
            text: 'Event ทุกประเภท',
            iconProps: { iconName: 'Page' },
            onClick: () => {
              console.log('Event ทุกประเภท');
              setEventType({ key: 'all', text: 'Event ทุกประเภท' });

              setLoadDataComplete(false);
              setItems([]);
              setGetNewDocuments(true);

              setTotalDocuments(0);
              setTotalSeverityInfo(0);
              setTotalSeverityWarning(0);
              setTotalSeverityError(0);
            },
            //['data-automation-id']: 'newEmailButton', // optional
          },
          {
            key: 'document',
            text: 'Document Event',
            iconProps: { iconName: 'Page' },
            onClick: () => {
              console.log('Document Event');
              setEventType({ key: 'document', text: 'Document Event' });

              setLoadDataComplete(false);
              setItems([]);
              setGetNewDocuments(true);

              setTotalDocuments(0);
              setTotalSeverityInfo(0);
              setTotalSeverityWarning(0);
              setTotalSeverityError(0);
            },
            //['data-automation-id']: 'newEmailButton', // optional
          },
          /* 
                      {
                        key: 'RECEIPT-TAXINVOICE-ABB',
                        text: 'ใบเสร็จรับเงิน/ใบกำกับภาษีอย่างย่อ',
                        iconProps: { iconName: 'Page' },
                        onClick: () => {
                          console.log('ใบเสร็จรับเงิน/ใบกำกับภาษีอย่างย่อ');
                          setEventType({ key: 'RECEIPT-TAXINVOICE-ABB', text: 'ใบเสร็จรับเงิน/ใบกำกับภาษีอย่างย่อ' });
          
                          setLoadDataComplete(false);
                          setItems([]);
                          setGetNewDocuments(true);
          
                          setTotalDocuments(0);
                          setTotalEsigns(0);
                          setTotalDsigns(0);
                        },
                        //['data-automation-id']: 'newEmailButton', // optional
                      },
            */
          {
            key: 'certificate',
            text: 'Certificate Event',
            iconProps: { iconName: 'Page' },
            onClick: () => {
              console.log('Certificate Event');
              setEventType({ key: 'certificate', text: 'Certificate Event' });

              setLoadDataComplete(false);
              setItems([]);
              setGetNewDocuments(true);

              setTotalDocuments(0);
              setTotalSeverityInfo(0);
              setTotalSeverityWarning(0);
              setTotalSeverityError(0);
            },
            //['data-automation-id']: 'newEmailButton', // optional
          },          
        ],
      },

    },
    {
      key: queryMonth.key,
      text: queryMonth.text,
      iconProps: { iconName: 'Calendar' },
      //href: 'https://developer.microsoft.com/en-us/fluentui',
      subMenuProps: {
        items: [
          {
            key: getMonth(0).key,
            text: getMonth(0).text,
            iconProps: { iconName: 'Calendar' },
            onClick: () => {
              console.log('Selected month: ', getMonth(0).key);
              setQueryMonth({ key: getMonth(0).key, text: getMonth(0).text });
              //setFirstLastDay(getMonth(0).month, getMonth(0).year);
              setFrom(getFrom(getMonth(0).month, getMonth(0).year));
              setTo(getTo(getMonth(0).month, getMonth(0).year));

              setLoadDataComplete(false);
              setItems([]);
              setGetNewDocuments(true);

              setTotalDocuments(0);
              setTotalSeverityInfo(0);
              setTotalSeverityWarning(0);
              setTotalSeverityError(0);
            },
            //['data-automation-id']: 'newEmailButton', // optional
          },
          {
            key: getMonth(1).key,
            text: getMonth(1).text,
            iconProps: { iconName: 'Calendar' },
            onClick: () => {
              console.log('Selected month: ', getMonth(1).key);
              setQueryMonth({ key: getMonth(1).key, text: getMonth(1).text });
              //setFirstLastDay(getMonth(1).month, getMonth(1).year);
              setFrom(getFrom(getMonth(1).month, getMonth(1).year));
              setTo(getTo(getMonth(1).month, getMonth(1).year));

              setLoadDataComplete(false);
              setItems([]);
              setGetNewDocuments(true);

              setTotalDocuments(0);
              setTotalSeverityInfo(0);
              setTotalSeverityWarning(0);
              setTotalSeverityError(0);
            },
            //['data-automation-id']: 'newEmailButton', // optional
          },
          {
            key: getMonth(2).key,
            text: getMonth(2).text,
            iconProps: { iconName: 'Calendar' },
            onClick: () => {
              console.log('Selected month: ', getMonth(2).key);
              setQueryMonth({ key: getMonth(2).key, text: getMonth(2).text });
              //setFirstLastDay(getMonth(2).month, getMonth(2).year);
              setFrom(getFrom(getMonth(2).month, getMonth(2).year));
              setTo(getTo(getMonth(2).month, getMonth(2).year));

              setLoadDataComplete(false);
              setItems([]);
              setGetNewDocuments(true);

              setTotalDocuments(0);
              setTotalSeverityInfo(0);
              setTotalSeverityWarning(0);
              setTotalSeverityError(0);
            },
            //['data-automation-id']: 'newEmailButton', // optional
          },
          {
            key: getMonth(3).key,
            text: getMonth(3).text,
            iconProps: { iconName: 'Calendar' },
            onClick: () => {
              console.log('Selected month: ', getMonth(3).key);
              setQueryMonth({ key: getMonth(3).key, text: getMonth(3).text });
              //setFirstLastDay(getMonth(3).month, getMonth(3).year);
              setFrom(getFrom(getMonth(3).month, getMonth(3).year));
              setTo(getTo(getMonth(3).month, getMonth(3).year));

              setLoadDataComplete(false);
              setItems([]);
              setGetNewDocuments(true);

              setTotalDocuments(0);
              setTotalSeverityInfo(0);
              setTotalSeverityWarning(0);
              setTotalSeverityError(0);
            },
            //['data-automation-id']: 'newEmailButton', // optional
          },
          {
            key: getMonth(4).key,
            text: getMonth(4).text,
            iconProps: { iconName: 'Calendar' },
            onClick: () => {
              console.log('Selected month: ', getMonth(4).key);
              setQueryMonth({ key: getMonth(4).key, text: getMonth(4).text });
              //setFirstLastDay(getMonth(4).month, getMonth(4).year);
              setFrom(getFrom(getMonth(4).month, getMonth(4).year));
              setTo(getTo(getMonth(4).month, getMonth(4).year));

              setLoadDataComplete(false);
              setItems([]);
              setGetNewDocuments(true);

              setTotalDocuments(0);
              setTotalSeverityInfo(0);
              setTotalSeverityWarning(0);
              setTotalSeverityError(0);
            },
            //['data-automation-id']: 'newEmailButton', // optional
          },
          {
            key: getMonth(5).key,
            text: getMonth(5).text,
            iconProps: { iconName: 'Calendar' },
            onClick: () => {
              console.log(getMonth(5).key);
              setQueryMonth({ key: getMonth(5).key, text: getMonth(5).text });
              //setFirstLastDay(getMonth(5).month, getMonth(5).year);
              setFrom(getFrom(getMonth(5).month, getMonth(5).year));
              setTo(getTo(getMonth(5).month, getMonth(5).year));

              setLoadDataComplete(false);
              setItems([]);
              setGetNewDocuments(true);

              setTotalDocuments(0);
              setTotalSeverityInfo(0);
              setTotalSeverityWarning(0);
              setTotalSeverityError(0);
            },
            //['data-automation-id']: 'newEmailButton', // optional
          },
        ]
      }
    },
/* 
    {
      key: 'download',
      text: 'ดาวน์โหลด',
      iconProps: { iconName: 'Download' },
      onClick: () => {
        console.log('Download');
      },
    },
     */
    {
      key: 'refresh',
      text: 'รีเฟรช',
      iconProps: { iconName: 'Refresh' },
      onClick: () => {
        console.log('Refresh');

        setLoadDataComplete(false);
        setDocuments([]);
        setItems([]);
        setGetNewDocuments(true);

        setTotalDocuments(0);
        setTotalSeverityInfo(0);
        setTotalSeverityWarning(0);
        setTotalSeverityError(0);
      },
    },
  ];

  const toThaiDateString = (isoDateTime) => {
    let date = '';
    date = new Date(isoDateTime);

    //console.log(dateTime.toLocaleDateString() + ' ' + dateTime.toLocaleTimeString());
    /* 
          let monthNames = [
            "มกราคม", "กุมภาพันธ์", "มีนาคม", "เมษายน",
            "พฤษภาคม", "มิถุนายน", "กรกฎาคม", "สิงหาคม.",
            "กันยายน", "ตุลาคม", "พฤศจิกายน", "ธันวาคม"
          ];
     */
    let year = date.getFullYear() + 543;
    //let month = monthNames[date.getMonth()];
    let month = (date.getMonth() + 1).toString().padStart(2, '0');
    let numOfDay = date.getDate().toString().padStart(2, '0');

    let hour = date.getHours().toString().padStart(2, '0');
    let minutes = date.getMinutes().toString().padStart(2, '0');
    let second = date.getSeconds().toString().padStart(2, '0');

    return `${numOfDay}/${month}/${year} ${hour}:${minutes}:${second} น.`;
  }

  const formatBytes = (bytes, decimals = 2) => {
    if (bytes === 0) return '0 Bytes';

    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

    const i = Math.floor(Math.log(bytes) / Math.log(k));

    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
  }
  /* 
useEffect(() => {
  if (account) {
      instance.acquireTokenSilent({
          scopes: ["User.Read"],
          account: account
      }).then((response) => {
          if(response) {
              callMsGraph(response.accessToken).then((result) => setApiData(result));
          }
      });
  }
}, [account, instance]);
     */

  const getTotalProcessingDocuments = () => {
    console.log('Get total processing document...');
    instance.acquireTokenSilent({ ...silentRequest, account: account }).then(tokenResponse => {

      //axios.get('https://etax.azure-api.net/company/b5cf38c9-5e52-4bd3-b737-caf5c6d30635')
      //axios.get('https://etax.azure-api.net/company/' + userId)
      //console.log(tokenResponse);
      //setUserFirstName(tokenResponse.idTokenClaims.given_name);

      //axios.get(API_URL + '/queues/processing/total', 
      axios.get(ADMIN_API_URL + '/etax/jobs/pdf/processing/total',
        {
          headers: {
            'Authorization': 'Bearer ' + tokenResponse.accessToken
          }
        })
        .then((response) => {

          console.log('Total processing jobs response: ', response);

          if (response.data[0]) {

            //console.log(JSON.stringify(response.data));
            console.log('Total processing jobs: ', response.data[0]);

            setTotalProcessingDocuments(response.data[0]);

          } else {

            setTotalProcessingDocuments(0);
          }

        }, (error) => {
          console.log(error);

        });

    }).catch(error => {

      //Acquire token silent failure, and send an interactive request
      console.log(error);
      instance.acquireTokenRedirect(silentRequest);

      /* 
                if (error.errorMessage.indexOf("interaction_required") !== -1) {
                    instance.acquireTokenRedirect(silentRequest);
                }
       */

    });
  }



  useEffect(() => {
    console.log('userEffect Call!');

    //console.log('UTC now: ', convertDateToUTC());



  }, []);

  useEffect(() => {
    console.log('userEffect getNewDocuments Call!');

    //let certificateName = {};

    //token = b2cauth.getAccessToken();

    //b2cauth.run();

    instance.acquireTokenSilent({ ...silentRequest, account: account }).then(tokenResponse => {
      // Do something with the tokenResponse
      console.log('Token response: ', tokenResponse);

      let _severityType = (severityType.key == 'all-severity') ? 'all' : severityType.key;
      console.log('_severityType: ', _severityType);

      //axios.get('https://ws.leceipt.com/documents', 
      //axios.get(API_URL + '/documents?type=ETAX&subtype=' + eventType.key + '&fileextension=xml&from=' + from + '&to=' + to, 
      axios.get(ADMIN_API_URL + '/audit-logs' + '?severity=' + _severityType  + '&eventType=' + eventType.key + '&from=' + from + '&to=' + to,
        {
          headers: {
            'Authorization': 'Bearer ' + tokenResponse.accessToken
          }
        })
        .then((response) => {

          console.log(response);
          console.log('Docs number: ', response.data.length);

          setTotalDocuments(response.data.length);

          //set page
          console.log('Page data: ', paginate(response.data.length, 1, 5, 10));
          setPageData(paginate(response.data.length, currentPage, pageSize, 10));
          /* 
                    const _docs = [];
          
                    response.data.forEach(doc => {
                      let documentName = '';
                      let fileSize = formatBytes(doc.fileSize);  
                      let createdTime = toThaiDateString(doc.createdTime);;
          
                      if (doc.type === 'ETAX') {
                        documentName = doc.data.name + ' ' + doc.data.number                            
                        
                      }
          
                      _docs.push({
                        key: doc.id,
                        fileName: doc.fileName + '.' + doc.fileExtension,
                        name: documentName,
                        value: doc.fileName,
                        //iconName: 'https://static2.sharepointonline.com/files/fabric/assets/item-types/16/xml.svg',
                        fileExtension: doc.fileExtension,
                        createdBy: doc.createdBy,
                        createdTime: createdTime,
                        createdTimeValue: doc.createdTime,
                        fileSize: fileSize,
                        fileSizeRaw: doc.fileSize,
                        type: doc.type,
                        signature: doc.signatures[0].certificateName,
                        //signature: certificateName[doc.certificateId],
                        //deliveryStatus: 'รอระบบนำส่ง'
              
                      });
                                    
                    });
          
                    setItems(_docs);
                    setLoadDataComplete(true);
                    //setClickDelete(false);
                    setGetNewDocuments(false);
                      */

          setDocuments(response.data);

          const _docs = [];

          if (response.data.length > 0) {

            for (let i = (currentPage - 1) * pageSize; i < Math.min(currentPage * pageSize, response.data.length); i++) {
              let occurredAt = toThaiDateString(response.data[i].occurredAt);

              _docs.push({
                key: response.data[i].id,
                severity: response.data[i].severity,
                occurredAt: occurredAt,
                eventType: response.data[i].eventType,
                action: response.data[i].action,
                actorId: response.data[i].actor.id,
                actorType: response.data[i].actor.type,
                targetId: response.data[i].target.id,
                targetType: response.data[i].target.type,
                status: response.data[i].status,
                clientIp: response.data[i].userContext?.ip?.clientIp,
                source: response.data[i].source || "",
                browser: response.data[i].userContext?.userAgent?.browser?.name || "",
              });

            }

            let _severityInfo = 0;
            let _severityWarning = 0;
            let _severityError = 0;

            for (let i = 0; i < response.data.length; i++) {

              if (response.data[i].severity === 'info') {
                _severityInfo++;
              }

              if (response.data[i].type === 'warning') {
                _severityWarning++;
              }

              if (response.data[i].type === 'error') {
                _severityError++;
              }

            }

            setTotalSeverityInfo(0);
            setTotalSeverityWarning(0);
            setTotalSeverityError(0);


          }

          console.log('Docs data', _docs);
          setItems(_docs);

          setLoadDataComplete(true);
          setGetNewDocuments(false);


        }, (error) => {
          console.log(error);
        });




    }).catch(error => {

      //Acquire token silent failure, and send an interactive request
      console.log(error);
      instance.acquireTokenRedirect(silentRequest);


    });



  }, [getNewDocuments]);

  useEffect(() => {

    if (documents.length > 0) {

      const _docs = [];

      for (let i = (currentPage - 1) * pageSize; i < Math.min(currentPage * pageSize, documents.length); i++) {
        let occurredAt = toThaiDateString(documents[i].occurredAt);

        _docs.push({
          key: documents[i].id,
          severity: documents[i].severity,
          occurredAt: occurredAt,
          eventType: documents[i].eventType,
          action: documents[i].action,
          actorId: documents[i].actor.id,
          actorType: documents[i].actor.type,
          targetId: documents[i].target.id,
          targetType: documents[i].target.type,
          status: documents[i].status,
          clientIp: documents[i].userContext?.ip?.clientIp,
          browser: documents[i].userContext?.userAgent?.browser?.name || "",
          source: documents[i].source || "",
        });

      }
      console.log('Docs data', _docs);




      setItems(_docs);
      //setLoadDataComplete(true);
      //setGetNewDocuments(false);
    }

  }, [currentPage]);

  const onPageChange = (selectedPageIndex) => {
    console.log('selectedPageIndex: ', selectedPageIndex);
    setCurrentPage(selectedPageIndex + 1);
  }

  const columns = [
    {
      key: 'column1',
      name: 'Severity',
      className: classNames.fileIconCell,
      iconClassName: classNames.fileIconHeaderIcon,
      // iconName: 'Page',
      // isIconOnly: true,
      fieldName: 'severity',
      minWidth: 50,
      maxWidth: 70,
      onColumnClick: '',
      onRender: (item) => {
        switch (item.severity) {
          case 'info':
            return <span style={{ display: 'block', textAlign: 'right', color: '#0078d4' }}>INFO</span>; // blue

          case 'warning':
            return <span style={{ display: 'block', textAlign: 'right', color: '#ff8c00' }}>WARNING</span>; // orange

          case 'error':
            return <span style={{ display: 'block', textAlign: 'right', color: '#d13438' }}>ERROR</span>; // red

          case 'critical':
            return (
              <span style={{ display: 'block', textAlign: 'right', color: '#a4262c', fontWeight: 600 }}>
                CRITICAL
              </span>
            ); // dark red + bold

          default:
            return <span style={{ display: 'block', textAlign: 'right', color: '#0078d4' }}>{item.severity}</span>;
        }
      }
      // isPadded: true,
    },
    {
      key: 'column2',
      name: 'Occurred At',
      fieldName: 'occurredAt',
      minWidth: 125,
      maxWidth: 125,
      isResizable: true,
      isSorted: true,
      isSortedDescending: true,
      onColumnClick: '',
      data: 'number',
      onRender: (item) => {
        return <span>{item.occurredAt}</span>;
      },
      // isPadded: true,
    },
    {
      key: 'column3',
      name: 'IP Address',
      fieldName: 'clientIp',
      minWidth: 50,
      maxWidth: 80,
      isResizable: true,
      //isSorted: true,
      //isSortedDescending: true,
      onColumnClick: '',
      data: 'string',
      onRender: (item) => {
        return <span>{item.clientIp}</span>;
      },
      // isPadded: true,
    },
    {
      key: 'column4',
      name: 'Event Type',
      fieldName: 'eventType',
      minWidth: 60,
      maxWidth: 80,
      isRowHeader: true,
      isResizable: true,
      isSorted: false,
      isSortedDescending: false,
      sortAscendingAriaLabel: 'Sorted A to Z',
      sortDescendingAriaLabel: 'Sorted Z to A',
      onColumnClick: '',
      data: 'string',
      onRender: (item) => {
        // return <span>{item.eventType}</span>;
        switch (item.eventType) {
          case 'document':
            return <span style={{ display: 'block', textAlign: 'right', }}>Document</span>; // blue
         
          case 'certificate':
            return <span style={{ display: 'block', textAlign: 'right', }}>Certificate</span>; // red

          default:
            return <span style={{ display: 'block', textAlign: 'right', }}>{item.eventType}</span>;;
        }
      },
      // isPadded: true,

    },
    {
      key: 'column5',
      name: 'Action',
      fieldName: 'action',
      minWidth: 100,
      maxWidth: 150,
      isResizable: true,
      //isSorted: true,
      //isSortedDescending: true,
      onColumnClick: '',
      data: 'string',
      onRender: (item) => {
        // return <span>{item.action}</span>;
        switch (item.action) {
          case 'document-digital-signed':
            return <span style={{ display: 'block', textAlign: 'left', }}>ลงลายเซ็นดิจิทัลบนเอกสาร</span>;
         
          case 'certificate-uploaded':
            return <span style={{ display: 'block', textAlign: 'left', }}>อัปโหลดใบรับรองอิเล็กทรอนิกส์</span>;

          case 'certificate-deleted':
            return <span style={{ display: 'block', textAlign: 'left', }}>ลบใบรับรองอิเล็กทรอนิกส์</span>;

          default:
            return <span style={{ display: 'block', textAlign: 'left', }}>{item.action}</span>;
        }
      },
      // isPadded: true,
    },
    {
      key: 'column6',
      name: 'Actor Type',
      fieldName: 'actorType',
      minWidth: 50,
      maxWidth: 70,
      isResizable: true,
      //isSorted: true,
      //isSortedDescending: true,
      onColumnClick: '',
      data: 'string',
      onRender: (item) => {
        // return <span>{item.actorType}</span>;
        switch (item.actorType) {
          case 'user':
            return <span style={{ display: 'block', textAlign: 'right', }}>User</span>;
         
          case 'admin':
            return <span style={{ display: 'block', textAlign: 'right', }}>Admin</span>;

          default:
            return <span style={{ display: 'block', textAlign: 'right', }}>{item.actorType}</span>;
        }
      },
      // isPadded: true,
    },
    {
      key: 'column7',
      name: 'Actor Id',
      fieldName: 'actorId',
      minWidth: 50,
      maxWidth: 150,
      isResizable: true,
      //isSorted: true,
      //isSortedDescending: true,
      onColumnClick: '',
      data: 'string',
      onRender: (item) => {
        return <span>{item.actorId}</span>;
      },
      // isPadded: true,
    },
    {
      key: 'column8',
      name: 'Target Type',
      fieldName: 'targetType',
      minWidth: 50,
      maxWidth: 80,
      isRowHeader: true,
      isResizable: true,
      isSorted: false,
      isSortedDescending: false,
      sortAscendingAriaLabel: 'Sorted A to Z',
      sortDescendingAriaLabel: 'Sorted Z to A',
      onColumnClick: '',
      data: 'string',
      onRender: (item) => {
        // return <span>{item.targetType}</span>;
        switch (item.targetType) {
          case 'document':
            return <span style={{ display: 'block', textAlign: 'right', }}>Document</span>;
         
          case 'certificate':
            return <span style={{ display: 'block', textAlign: 'right', }}>Certificate</span>;

          default:
            return <span style={{ display: 'block', textAlign: 'right', }}>{item.targetType}</span>;
        }
      },
      // isPadded: true,

    },
    {
      key: 'column9',
      name: 'Target Id',
      fieldName: 'targetId',
      minWidth: 50,
      maxWidth: 150,
      isRowHeader: true,
      isResizable: true,
      isSorted: false,
      isSortedDescending: false,
      sortAscendingAriaLabel: 'Sorted A to Z',
      sortDescendingAriaLabel: 'Sorted Z to A',
      onColumnClick: '',
      data: 'string',
      onRender: (item) => {
        return <span>{item.targetId}</span>;
      },
      // isPadded: true,
    },
    {
      key: 'column10',
      name: 'Source',
      fieldName: 'source',
      minWidth: 50,
      maxWidth: 50,
      isResizable: true,
      //isSorted: true,
      //isSortedDescending: true,
      onColumnClick: '',
      data: 'string',
      onRender: (item) => {
        // return <span>{item.browser}</span>;
        switch (item.source) {
          case 'web':
            return <span style={{ display: 'block', textAlign: 'right', }}>Web</span>; 
         
          case 'api':
            return <span style={{ display: 'block', textAlign: 'right', }}>Api</span>; 

          default:
            return <span style={{ display: 'block', textAlign: 'right', }}>{item.source}</span>;;
        }
      },
      // isPadded: true,
    },
    {
      key: 'column11',
      name: 'Browser',
      fieldName: 'browser',
      minWidth: 50,
      maxWidth: 50,
      isResizable: true,
      //isSorted: true,
      //isSortedDescending: true,
      onColumnClick: '',
      data: 'string',
      onRender: (item) => {
        return <span>{item.browser}</span>;
      },
      // isPadded: true,
    },    
    {
      key: 'column12',
      name: 'Status',
      fieldName: 'status',
      minWidth: 50,
      maxWidth: 50,
      isResizable: true,
      //isSorted: true,
      //isSortedDescending: true,
      onColumnClick: '',
      data: 'string',
      onRender: (item) => {
        // return <span>{item.status}</span>;
        switch (item.status) {
          case 'success':
            return <span style={{ display: 'block', textAlign: 'left', }}>Success</span>; 
         
          case 'fail':
            return <span style={{ display: 'block', textAlign: 'left', }}>Fail</span>; 

          default:
            return <span style={{ display: 'block', textAlign: 'left', }}>{item.status}</span>;;
        }
      },
      // isPadded: true,
    },
  ];

  const isCompactMode = false;
  //const isModealSelection = false;
  //const annoucedMessage = undefined;



  return (
    <div style={homeStyles}>
      <Stack>
        <center>
          <h2 style={{ marginLeft: '0px', marginTop: '25px' }}>Frevation eSigns - Audit Logs</h2>
        </center>


      </Stack>

      <Stack
        horizontal
        horizontalAlign="center"
      >
        <Stack vertical style={{
          width: '98%',
          //minWidth: '1070px', 
          maxWidth: '1350px'
        }}>
          <CommandBar
            items={commandBarItems}
          //overflowItems={_overflowItems}
          //overflowButtonProps={overflowProps}
          //farItems={_farItems}
          //ariaLabel="Use left and right arrow keys to navigate between commands"
          />
          <ShimmeredDetailsList
            items={items || []}
            enableShimmer={!loadDataComplete}
            compact={isCompactMode}
            columns={columns}
            selectionMode={SelectionMode.none}
            //selectionMode={SelectionMode.multiple}
            //getKey="1"
            //setKey="set"
            layoutMode={DetailsListLayoutMode.justified}
            isHeaderVisible={true}
          //selection={Selection}
          //selectionPreservedOnEmptyClick={true}
          //onItemInvoked={download}
          //enterModalSelectionOnTouch={true}
          //ariaLabelForSelectionColumn="Toggle selection"
          //ariaLabelForSelectAllCheckbox="Toggle selection for all items"
          //checkButtonAriaLabel="Row checkbox"
          //onRenderItemColumn={ this.onRenderItemColumn }
          //listProps={shimmeredDetailsListProps}
          />
        </Stack>
      </Stack>
      {/* </Fabric> */}
      <br /><center>
        {!(documents.length === 0 || documents.length < pageSize) && <Pagination
          //selectedPageIndex={page}
          selectedPageIndex={currentPage - 1}
          //pageCount={pageCount}
          pageCount={pageData.totalPages}
          onPageChange={onPageChange}
          format
          firstPageIconProps={{ iconName: 'DoubleChevronLeft' }}
          previousPageIconProps={{ iconName: 'ChevronLeft' }}
          nextPageIconProps={{ iconName: 'ChevronRight' }}
          lastPageIconProps={{ iconName: 'DoubleChevronRight' }}
        />}

        <br />
        <br />

        {/* 
            <br/>
            <a href="http://nav.cx/3p1xabz" target="_blank">
                <img src={PUBLIC_URL + '/images/line-add-friend.png'} alt="เพิ่มเพื่อน" height="36" border="0"></img>
            </a>
            <br/>
            <br/>
            <div>ฝ่ายบริการลูกค้า Line: @leceipt</div>
            <br/>
            <div>โทร. 082-579-8555</div>
            <br/>
            <div>เวลาทำการ 8.30 น. - 17.30 น. ทุกวัน</div>
 */}
      </center>

    </div>
  );

}

export default Documents;